<template>
  <v-speed-dial v-model="fab_aspect" direction="bottom" class="speeddial">
    <template v-slot:activator>
      <v-btn small depressed rounded class="speed-dial-activator">
        <v-icon small v-if="fab_aspect">close</v-icon>
        <v-icon v-else small>aspect_ratio</v-icon>
      </v-btn>
    </template>

    <v-btn-toggle
      dense
      rounded
      borderless
      v-model="tavoloLayoutModel"
      mandatory
    >
      <v-btn
        class="speed-dial-btn"
        :value="Constants.TAVOLO_LAYOUT.CERCHIO"
        @click.stop
      >
        <v-icon :class="colorSpeedDial" small>lens</v-icon>
      </v-btn>
      <v-btn
        class="speed-dial-btn"
        :value="Constants.TAVOLO_LAYOUT.GRIGLIA"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">view_module</v-icon>
      </v-btn>
    </v-btn-toggle>

    <v-btn-toggle
      v-show="tavoloLayoutModel == Constants.TAVOLO_LAYOUT.CERCHIO"
      dense
      rounded
      borderless
      class="icone-cerchi"
      v-model="tavoloSizeModel"
      mandatory
    >
      <v-btn
        class="speed-dial-btn"
        :value="Constants.TAVOLO_SIZE.SMALL"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">lens</v-icon>
      </v-btn>
      <v-btn
        class="speed-dial-btn"
        :value="Constants.TAVOLO_SIZE.MEDIUM"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">lens</v-icon>
      </v-btn>
      <v-btn
        class="speed-dial-btn"
        :value="Constants.TAVOLO_SIZE.LARGE"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">lens</v-icon>
      </v-btn>
    </v-btn-toggle>

    <v-btn-toggle
      dense
      rounded
      borderless
      class="icone-cerchi"
      v-model="squadreSizeModel"
      mandatory
    >
      <v-btn
        class="speed-dial-btn"
        :value="Constants.SQUADRE_SIZE.SMALL"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">account_box</v-icon>
      </v-btn>
      <v-btn
        class="speed-dial-btn"
        :value="Constants.SQUADRE_SIZE.MEDIUM"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">account_box</v-icon>
      </v-btn>
      <v-btn
        class="speed-dial-btn"
        :value="Constants.SQUADRE_SIZE.LARGE"
        @click.stop
      >
        <v-icon :class="colorSpeedDial">account_box</v-icon>
      </v-btn>
    </v-btn-toggle>
  </v-speed-dial>
</template>

<script>
import Vuex from "vuex";
import mixins from "../../js/mixins";

export default {
  name: "user-preferences-speed-dial",
  mixins: [mixins],
  data() {
    return {
      fab_aspect: false,
    };
  },
  computed: {
    ...Vuex.mapGetters([
      "tavoloLayout",
      "tavoloSize",
      "squadreSize",
    ]),
    colorSpeedDial() {
      return "white--text";
    },
    tavoloLayoutModel: {
      get() {
        return this.tavoloLayout;
      },
      set(value) {
        if (value == this.Constants.TAVOLO_LAYOUT.CERCHIO) {
          let nSquadre = _.size(this.asta_squadre);
          let limit = this.Constants.LIMIT_SQUADRE_LAYOUT_CERCHIO;
          if (nSquadre > limit) {
            Swal.fire({
              icon: "info",
              title: "Suggerimento",
              text:
                "In leghe con più di " +
                limit +
                ' squadre è preferibile la visualizzazione a "griglia" e non a "tavolo rotondo" per evitare sovrapposizioni',
              confirmButtonText: "Ok, ho capito",
            });
          }
        }
        this.$store.dispatch("setTavoloLayout", value);
        if (value == this.Constants.TAVOLO_LAYOUT.CERCHIO) {
          this.$store.dispatch(
            "setSquadreSize",
            this.Constants.SQUADRE_SIZE.SMALL
          );
        }
      },
    },
    tavoloSizeModel: {
      get() {
        return this.tavoloSize;
      },
      set(value) {
        this.$store.dispatch("setTavoloSize", value);
      },
    },
    squadreSizeModel: {
      get() {
        return this.squadreSize;
      },
      set(value) {
        this.$store.dispatch("setSquadreSize", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.speed-dial-activator {
  background: var(--v-navy-base) !important;
  color: white !important;
}

.speed-dial-btn {
  background: var(--v-navy-base) !important;
  color: white !important;
  font-weight: bold;
  margin: 0 0 6px 0;
}

.speed-dial-activator:hover,
.speed-dial-btn:hover {
  background: var(--v-navy-base) !important;
}

.speeddial {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 201;

  &::v-deep .v-speed-dial__list {
    align-items: flex-end;
    z-index: 201;
  }

  .v-btn-toggle {
    margin: 0 0 6px 0;
    flex-direction: row-reverse;
    background: transparent;

    > .v-btn.v-btn:first-child {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    > .v-btn.v-btn:last-child {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .v-btn {
      margin: 0;
      opacity: 1;

      &.v-item--active {
        color: transparent;
        background: var(--v-navy-lighten3) !important;
      }
    }

    &.icone-cerchi {
      .v-btn {
        &:first-child i {
          font-size: 12px;
        }

        i {
          font-size: 16px;
        }

        &:last-child i {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
